import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { PageHeader } from '@/components/ui/PageHeader'
import { useDashboardStore } from '@/store/dashboard.store'

import { DashboardKPI } from './components/DashboardKPI'
import { RecentReports } from './components/RecentReports'

export default function Dashboard() {
  const { t } = useTranslation()
  const { recentReports, kpis, fetchDashboardData } = useDashboardStore()

  useEffect(() => {
    fetchDashboardData()
  }, [fetchDashboardData])

  const stats = [

    { label: t('dashboard.kpi.total_reports'), value: kpis.totalReports, sub: t('dashboard.kpi.total_reports_desc') },
    { label: t('dashboard.kpi.total_payout'), value: kpis.totalPayout.toFixed(0), sub: t('dashboard.kpi.total_payout_desc') },
  ]


  return (
    <div className="p-5 space-y-8">
      <PageHeader
        title={t('dashboard.title')}
        subtitle={t('dashboard.subtitle')}
      />
      <DashboardKPI stats={stats} />
      <RecentReports
        reports={recentReports}
      />
    </div>
  )
}
